import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FishAccordion, FishPanel, FishPanelTitle, FishPanelContent, FishPanelChangeEvent } from './accordion';
import { FishAccordionConfig } from './accordion-config';

export { FishAccordion, FishPanel, FishPanelTitle, FishPanelContent, FishPanelChangeEvent } from './accordion';
export { FishAccordionConfig } from './accordion-config';

const FISH_ACCORDION_DIRECTIVES = [FishAccordion, FishPanel, FishPanelTitle, FishPanelContent];


export class FishAccordionModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishAccordionModule, providers: [FishAccordionConfig] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: FISH_ACCORDION_DIRECTIVES,
  exports: FISH_ACCORDION_DIRECTIVES,
  imports: [CommonModule]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
